import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import { block } from '../utils';
import YouTubeMediaUploadModalContents from './YouTubeMediaUploadModalContents';

export interface YouTubeMediaUploadModalProps {}

const YouTubeMediaUploadModal: React.FC<YouTubeMediaUploadModalProps> = () => {
  return (
    <ConnectedModal name="YouTubeMediaUpload" className={block('container')}>
      <YouTubeMediaUploadModalContents />
    </ConnectedModal>
  );
};

export default YouTubeMediaUploadModal;
